import React from 'react';
import Validator from "./Validator";
import { Alert } from "../Components/Alert";

var validator = new Validator();
var error_messages;

export default class InputHandler {
  constructor(errors) {
    error_messages = errors;
  }
  
  handleBasicInputChange(e, c) {
    let { errors, user_input, form_is_valid } = c.state;
    user_input[e.target.name] = e.target.value;
    errors[e.target.name] = '';
    form_is_valid = true;

    if (validator.inputIsEmpty(e.target.value) && e.target.attributes.required) {
      errors[e.target.name] = (<Alert
        type="alert-danger"
        text={error_messages[e.target.name].required}
      />);
    }
    form_is_valid = validator.checkForErrors(errors, "default_error");
    c.setState({ user_input, errors, form_is_valid });
  }

  handleDateChange(date, c, name, required) {
    let { errors, user_input, form_is_valid } = c.state;
    user_input[name] = date;
    errors[name] = '';
    form_is_valid = true;

    if (validator.inputIsEmpty(user_input[name]) && required) {
      errors[name] = (<Alert
        type="alert-danger"
        text={error_messages[name].required}
      />);
    }
    form_is_valid = validator.checkForErrors(errors, "default_error");
    user_input[name] = date;
    c.setState({ user_input, errors, form_is_valid });
  }

  handleSelectChange(e, c, defaultSelect) {
    let { errors, user_input, form_is_valid } = c.state;
    user_input[e.target.name] = e.target.value;
    errors[e.target.name] = '';
    form_is_valid = true;

    if (validator.inputIsEqualTo(defaultSelect, user_input[e.target.name]) && e.target.attributes.required) {
      errors[e.target.name] = (<Alert
        type="alert-danger"
        text={error_messages[e.target.name].required}
      />);
    }
    form_is_valid = validator.checkForErrors(errors, "default_error");
    c.setState({ errors, user_input, form_is_valid });
  }

  handleCheckboxChange(e, c) {
    let { errors, user_input, form_is_valid } = c.state;
    errors[e.target.name] = '';
    user_input[e.target.name] = e.target.checked;

    if (!e.target.checked && e.target.attributes.required) {
      errors[e.target.name] = (<Alert
        type="alert-danger"
        text={error_messages[e.target.name].required}
      />);
    }
    form_is_valid = validator.checkForErrors(errors, "default_error");
    c.setState({ errors, user_input, form_is_valid });
  }

  handleCheckboxGroupChange(e, c, group) {
    let { errors, user_input, form_is_valid } = c.state;
    errors[group] = '';
    user_input[group][e.target.name].is_checked = e.target.checked;

    if (validator.allCheckboxesInGroupUnchecked(user_input[group])) {
      errors[group] = (<Alert
        type="alert-danger"
        text={error_messages[group].required}
      />);
    }

    form_is_valid = validator.checkForErrors(errors, "default_error");
    c.setState({ errors, user_input, form_is_valid });
  }

  handleRadioGroupChange(e, c, group) {
    let { errors, user_input, form_is_valid } = c.state;
    errors[group] = '';
    user_input[group].selected_option = e.target.name;

    form_is_valid = validator.checkForErrors(errors, "default_error");
    c.setState({ errors, user_input, form_is_valid });
  }
}
